// extracted by mini-css-extract-plugin
export var col = "index-module--col--281bc";
export var hideDot = "index-module--hide-dot--da09f";
export var wrapper = "index-module--wrapper--c7ff9";